/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { ActiveDirectorySettings } from '@modules/cloud-api/v1/types'

import { createActiveDirectorySecurityRealmRequest } from '@/apps/adminconsole/reducers/registry'

import { createActiveDirectorySecurityRealm, fetchSecurityCluster } from '../../../../../actions'

import AddActiveDirectoryProvider from './AddActiveDirectoryProvider'

const mapStateToProps = (
  state,
  {
    match: {
      params: { regionId },
    },
  },
) => ({
  regionId,
  submitRequest: createActiveDirectorySecurityRealmRequest(state, regionId),
})

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { regionId },
    },
  },
) => ({
  onSubmit: (payload: ActiveDirectorySettings) =>
    dispatch(createActiveDirectorySecurityRealm(regionId, payload)).then(() =>
      dispatch(fetchSecurityCluster(regionId)),
    ),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddActiveDirectoryProvider)
